var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-hero2"},[_c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"challange-target"}},[_vm._v("hidden")]),_c('div',{staticClass:"row marginTop"},[_c('div',{staticClass:"col-md-12"},[_c('images')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }